import { render } from "./ArgonModal.vue?vue&type=template&id=d85cb418"
import script from "./ArgonModal.vue?vue&type=script&lang=js"
export * from "./ArgonModal.vue?vue&type=script&lang=js"

import "./ArgonModal.vue?vue&type=style&index=0&id=d85cb418&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__